/** PC 端入駐表單（join/components/pc）；與 corporateCenter.joinM 互補 */
export default {
	translate: {
		success: "翻譯成功",
		failRetry: "翻譯失敗，請重試",
		fail: "翻譯失敗",
	},
	table: {
		delete: "刪除",
		operation: "操作",
		type: "類型",
		number: "號碼",
		businessDay: "營業日",
		businessTime: "營業時段",
		emptyBusinessHours: "暫無營業時間",
		emptyPhones: "暫無聯繫電話",
		emptyServices: "暫無服務",
	},
	breadcrumb: {
		myMerchant: "我的機構",
		join: "機構入駐",
	},
	steps: {
		step1: "填寫機構信息",
		step2: "填寫資質",
		step3: "等待審核",
	},
	page: {
		loading: "加載中...",
		submitting: "正在提交審核...",
		submitOk: "提交成功，等待審核",
		submitFail: "提交失敗，請重試",
		saving: "正在保存...",
		saveOk: "保存成功",
		saveFail: "保存失敗，請重試",
		mockOk: "測試數據已填充完成！",
		mockBtn: "一鍵填充測試數據",
	},
	formRules: {
		registrationCertificate: "請上傳社團登記證",
		managerName: "請填寫管理者姓名",
		managerPhoneNumber: "請填寫管理者聯繫方式",
		managerContactType: "請選擇聯繫方式類型",
		name: "請輸入機構名稱",
		name_en: "請填寫英文機構名稱",
		merchant_type: "請選擇機構分類",
		business_status: "營業狀態不能為空",
		country: "請選擇國家/地區",
		region_code: "請選擇省/市/區",
		address: "請填寫詳細地址",
		coordinates: "請獲取經緯度",
		detailTraditional: "請輸入機構詳情（繁體）",
		detailEnglish: "請輸入機構詳情（英文）",
		cover: "請上傳機構圖片",
		managerIntroductionMax: "簡介不能超過500個字符",
		images: "請上傳商家圖片",
	},
	qualification: {
		orgAddressPh: "請填寫機構地址",
		managerContact: "管理者聯繫方式",
		placeSelect: "請選擇",
		emailPh: "請填寫郵箱地址",
		mobilePh: "請填寫手機號碼",
		uploadAlt: "上傳圖片",
		certificateTip: "*使用社團登記證原件拍照,證件文字清晰",
		pickImage: "請選擇圖片文件",
		imageMax5mb: "圖片大小不能超過 5MB",
		uploadNoUrl: "上傳失敗：未返回圖片URL",
		uploadSuccess: "圖片上傳成功",
		uploadFail: "圖片上傳失敗",
		protocolInfo: "協議內容將在新窗口打開",
		validateFail: "請檢查表單填寫是否正確",
		fileListName: "社團登記證",
		managerCountryPlaceholder: "+852 中國香港",
	},
	address: {
		fetchCountryFail: "獲取地區代碼失敗",
		fetchRegionFail: "獲取區域列表失敗",
		labelCountry: "國家/地區",
		phCountry: "請選擇國家/地區",
		phAddressInfo: "請選擇省/市/區",
		phDetail: "請填寫詳細地址, 精確到門牌號",
		phDetailEn: "請填寫英文詳細地址",
		phCoords: "點擊按鈕獲取經緯度",
		getBtn: "獲取",
		needDetailFirst: "請先填寫詳細地址",
		needCountry: "請先選擇國家/地區",
		needRegion: "請先選擇地址信息",
		needDetailCoords: "請先填寫詳細地址",
		coordsOk: "經緯度獲取成功",
		coordsEmpty: "未能獲取到經緯度信息",
		coordsFail: "獲取經緯度失敗",
		fallbackHK: "中國香港",
		fallbackTW: "中國台灣",
	},
	manager: {
		title: "管理人介紹",
		image: "圖片",
		ratioTip: "寬高比1 : 1.34，建議使用清晰的個人正面形象照",
		introZh: "簡介",
		introEn: "英文簡介",
		phIntroZh: "請填寫管理人簡介",
		phIntroEn: "請填寫管理人英文簡介",
		needIntroFirst: "請先輸入管理人簡介",
	},
	media: {
		sectionTitle: "機構媒體",
		coverRatioTip: "寬高比 1 : 1.34",
		imagesTip: "最多上傳 10 張，1.45:1，左上角可拖拽排序",
		videoPreviewTitle: "視頻預覽",
		videoTipPc: "支持 MP4、AVI、MOV 等格式，最大 50MB，一次只能上傳 1 個",
	},
	serviceSection: {
		title: "服務設置",
		add: "添加服務",
		thImage: "圖片",
		thName: "服務名稱",
		thNameEn: "英文名稱",
		thPrice: "價格（美元）",
		noImage: "暫無圖片",
		edit: "編輯",
		remove: "移除",
	},
	serviceModalPc: {
		serviceImage: "服務圖片",
		imageRatioTip: "寬高比 1:1，建議使用清晰的機構服務圖片",
		titleName: "服務名稱",
		titleNameEn: "英文服務名稱",
		titleIntro: "服務簡介",
		titleIntroEn: "英文服務簡介",
		titleDetailZh: "服務詳情 (繁體)",
		titleDetailEn: "服務詳情 (英文)",
		titlePrice: "服務價格（美元）",
		phName: "請填寫服務名稱",
		phNameEn: "請填寫英文服務名稱",
		phIntro: "請填寫服務簡介",
		phIntroEn: "請填寫英文服務簡介",
		phDetail: "請輸入服務詳情",
		phPrice: "請輸入服務價格（美元）",
		needName: "請先輸入服務名稱",
		needIntro: "請先輸入服務簡介",
		needDetailZh: "請先輸入服務詳情（繁體）",
		warnName: "請輸入服務名稱",
		warnNameEn: "請輸入英文服務名稱",
		warnPrice: "請輸入有效的服務價格（美元）",
		warnIntro: "請輸入服務簡介",
		warnIntroEn: "請輸入英文服務簡介",
		warnDetailZh: "請輸入服務詳情（繁體）",
		warnDetailEn: "請輸入服務詳情（英文）",
	},
	businessHourPc: {
		hourPlaceholder: "00時",
		minutePlaceholder: "00分",
	},
	previewModal: {
		title: "預覽",
		loading: "加載中...",
	},
	detail: {
		phDetail: "請輸入機構詳情",
	},
	basicInfo: {
		needOrgName: "請先輸入機構名稱",
		needDetailZh: "請先輸入繁體機構詳情",
		serviceUpdated: "服務更新成功",
		serviceAdded: "服務添加成功",
		deleting: "正在刪除服務...",
		deleted: "服務已刪除",
		deleteFail: "刪除失敗，請重試",
		removed: "服務已移除",
		needBusinessHour: "請至少添加一個營業時間",
		needPhone: "請至少添加一個聯繫電話",
		validateFail: "請檢查表單填寫是否正確",
	},
	header: {
		logoText: "先知命局合作中心",
		logout: "登出",
		kefuAlt: "客服",
		transferAlt: "轉化",
		nicknameFallback: "這裡是用戶昵稱",
		langHintZh: "切換到英文",
		langHintEn: "切換到繁體中文",
	},
	actions: {
		back: "返回",
		preview: "預覽",
		save: "保存",
		next: "下一步",
		submitReview: "提交審核",
	},
};
